var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconEdit = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M0 0.186L3.146 0.186 3.146 3.333 0 3.333z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__c",
    d: "M0.222 0.162L15.222 0.162 15.222 15.196 0.222 15.196z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0z",
    transform: "translate(.5)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5) translate(2.667 2.667) translate(0 15.505)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M3.146 1.759c0 .87-.704 1.574-1.573 1.574C.705 3.333 0 2.628 0 1.76 0 .89.705.186 1.573.186c.869 0 1.573.704 1.573 1.573",
    mask: "url(#prefix__b)",
    opacity: 0.64
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(.5) translate(2.667 2.667) translate(3.333 .172)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#1A1919",
    d: "M9.902.634L8.05 2.51l-.703.707-4.753 4.795c-.17.17-.3.383-.377.612L.25 14.487c-.065.193-.015.407.13.552.103.102.24.157.38.157.057 0 .115-.01.172-.028l5.825-1.973c.232-.079.445-.212.617-.386l4.758-4.792 2.629-2.645c.301-.303.466-.706.461-1.135-.005-.428-.177-.828-.486-1.125L12.13.605c-.297-.286-.688-.443-1.1-.443-.427 0-.828.167-1.128.472zm-1.056 2.6l1.82-1.845c.098-.098.227-.152.365-.152.132 0 .257.05.353.143l2.607 2.508c.098.095.154.224.156.36 0 .139-.051.269-.149.366l-1.896 1.909-3.256-3.288zm-5.61 5.732c.026-.074.068-.142.122-.196l4.73-4.772.488.492-4.71 4.742-.856 2.565.587.584 2.547-.863 4.702-4.736.498.504-4.733 4.766c-.055.056-.124.099-.198.124l-4.8 1.625 1.624-4.835zm1.565 1.619c-.123-.114-.185-.26-.185-.436 0-.171.062-.318.185-.443l4.477-4.508.87.88-4.475 4.507c-.123.124-.27.187-.44.187-.17 0-.313-.063-.432-.187z",
    mask: "url(#prefix__d)",
    opacity: 0.64
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconEdit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_edit.c0b9a8de65609a54975a1e8ce4ff0d54.svg";